window.k1ValidateForm = {
	getPhoneInput: function () {
		return false;
	},

	validateEmail: function (email) {
		let regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		return regex.test(email)
	},

	maskInputPhone: function (inputPhone) {
		let input = inputPhone;
		let mask = input.dataset.mask;
		let value = input.value;
		let literalPattern = /[0\*]/;
		let numberPattern = /[0-9]/;
		let newValue = "";

		// if ( inputPhone.getAttribute('id') != 'soa-property-3')
			if (value[0] == '8') mask = '8 (000) 000-00-00';

		try {
			let maskLength = mask.length;
			let valueIndex = 0;
			let maskIndex = 0;

			for (; maskIndex < maskLength;) {

				if (maskIndex >= value.length) break;

				if (mask[maskIndex] === "0" && value[valueIndex].match(numberPattern) === null) {
					break;
				}
				// Found a literal
				while (mask[maskIndex].match(literalPattern) === null) {

					if (value[valueIndex] === mask[maskIndex]) {
						break;
					}
					newValue += mask[maskIndex++];
				}

				newValue += value[valueIndex++];
				maskIndex++;
			}

			input.value = newValue;

		} catch (e) {
			console.log(e);
		}
	},

	validateAddress: function () {
		let region, city, street, num, error = false;

		region = document.querySelector("#k1-order-delivery-region");
		city = document.querySelector("#k1-order-delivery-city");
		street = document.querySelector("#k1-order-delivery-street");
		number = document.querySelector("#k1-order-delivery-number");

		if (!region.value) {
			region.closest(".default-form-input-text-js").classList.add("k1-error");
			error = true;
		} else {
			region.closest(".default-form-input-text-js").classList.remove("k1-error")
		}
		if (!city.value) {
			city.closest(".default-form-input-text-js").classList.add("k1-error");
			error = true;
		} else {
			city.closest(".default-form-input-text-js").classList.remove("k1-error")
		}
		if (!street.value) {
			street.closest(".default-form-input-text-js").classList.add("k1-error");
			error = true;
		} else {
			street.closest(".default-form-input-text-js").classList.remove("k1-error")
		}
		if (!number.value) {
			number.closest(".default-form-input-text-js").classList.add("k1-error");
			error = true;
		} else {
			number.closest(".default-form-input-text-js").classList.remove("k1-error")
		}
		if (error) return false;
		// if (!city.value) return false;
		// if (!street.value) return false;
		// if (!num.value) return false;
	},

	init: function () {

		let maskedInputs = document.querySelectorAll("[data-mask]");

		for (let index = 0; index < maskedInputs.length; index++) {
			// maskedInputs[index].value = "";
			window.k1ValidateForm.maskInputPhone(maskedInputs[index]);
			BX.bind(maskedInputs[index], "input", function () {
				window.k1ValidateForm.maskInputPhone(maskedInputs[index]);
			})
		}
	}
};

window.addEventListener("DOMContentLoaded", function () {
	window.k1ValidateForm.init();

});